import { render, staticRenderFns } from "./CloudProductBatchEdit.vue?vue&type=template&id=38c4f2ce&scoped=true"
import script from "./CloudProductBatchEdit.vue?vue&type=script&lang=js"
export * from "./CloudProductBatchEdit.vue?vue&type=script&lang=js"
import style0 from "./CloudProductBatchEdit.vue?vue&type=style&index=0&id=38c4f2ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c4f2ce",
  null
  
)

export default component.exports